import { Layout } from "../components/Layout";
import { ViewArtical } from "../modules/content-center/templates/view";

const PageArticle = () => (
  <Layout>
    <ViewArtical />
  </Layout>
);

export default PageArticle;
